import { TwilioWallSync } from '@streem/sdk-twilio-wall';
import { streem, WallItem } from 'streem-sdk-protobuf';
import { logger } from '../../util/logger';
import WallTokenUtil from './wall_token_util';
import { StreemError } from '../../streem_error';
class WallSyncBuilder {
    constructor(wallItemClass, connectionId, wallId) {
        this.wallItemClass = wallItemClass;
        this.connectionId = connectionId;
        this.wallId = wallId;
    }
    async build() {
        const creds = await this.fetchCreds();
        const syncOpts = {
            wallId: this.wallId,
            initialCreds: creds,
            refreshToken: this.fetchCreds.bind(this),
            onDisconnect: this.disconnect,
            connectionId: this.connectionId,
        };
        logger.info(`${this.constructor.name} initializing ${creds.syncService}WallSync.`);
        if (creds.syncService === 'twilio') {
            return new TwilioWallSync(this.wallItemClass, syncOpts);
        }
        else {
            logger.error(`UserWallSync failed to build, unsupported wall sync service provided: ${creds.syncService}`);
            throw new StreemError('Unsupported Wall Sync Service provided');
        }
    }
}
export class UserWallSyncBuilder extends WallSyncBuilder {
    constructor(userId, connectionId) {
        super(streem.user.UserWallItem, connectionId.toString(), userId.toString());
        this.userId = userId;
    }
    async fetchCreds() {
        try {
            logger.info(`UserWallSync refreshing Token.`);
            await WallTokenUtil.userClientCred.fetch(this.userId);
            return WallTokenUtil.userClientCred.getWallCreds();
        }
        catch (e) {
            logger.error(`UserWallSync failed to refresh room wall credentials`, e);
            throw e;
        }
    }
    disconnect() {
        WallTokenUtil.userClientCred.disconnect();
        logger.info('UserWallSync disconnected.');
    }
}
export class RoomWallSyncBuilder extends WallSyncBuilder {
    constructor(roomId, connectionId, userId, readOnly) {
        super(WallItem, connectionId.toString(), roomId.toString());
        this.roomId = roomId;
        this.userId = userId;
        this.readOnly = readOnly;
    }
    async fetchCreds() {
        try {
            logger.info(`RoomWallSync refreshing Token.`);
            await WallTokenUtil.roomWallClientCred.fetch(this.roomId, this.userId, this.readOnly);
            const roomWallCredentials = WallTokenUtil.roomWallClientCred.getWallCreds();
            return roomWallCredentials;
        }
        catch (e) {
            logger.error(`RoomWallSync failed to refresh room wall credentials`, e);
            throw e;
        }
    }
    disconnect() {
        WallTokenUtil.roomWallClientCred.disconnect();
        logger.info('RoomWallSync disconnected.');
    }
}
//# sourceMappingURL=wall_sync_builder.js.map